import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { AtiraLinkThemes } from '../model/atira-link/types/AtiraLinkThemes.enum';

/** This hook is used when the app loads with theme params.
 *  this usually happens when the user clicks on a theme in atiralink.com/templates
 */
export const useShouldSetTheme = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (!state) {
      return;
    }

    const url = new URL(state.from);

    const searchParams = new URLSearchParams(url.search);
    const theme = searchParams.get('theme') as AtiraLinkThemes | null;

    if (theme && Object.keys(AtiraLinkThemes).includes(theme)) {
      localStorage.setItem('selectedThemeFromTemplates', theme);
      navigate('/my-link');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
